module.exports = __webpack_public_path__ + "static/media/pms_graph.d816adb9.png";